import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import { AS_BUTTON } from './Links.constants';
import { generateKey } from './Links.utils';
import { AsPropType, SiteNavigationLinkPropType } from '../../../../../../services/proptypes';
import { createComponent } from '../../../../../foundation/services/components';
import { groupLinks } from '../../../../services/links';
import DropdownMenu from '../DropdownMenu';
import BaseLink from '../Link';
import { DEFAULT_LINK_AS } from '../Link/Link.constants';
import PopupAccordionMenuLink from '../PopupAccordionsMenuLink/PopupAccordionMenuLink';
var defaultProps = {
  linksAs: DEFAULT_LINK_AS,
  renderChildPages: PopupAccordionMenuLink
};
function Links(_ref) {
  var links = _ref.links,
    linksAs = _ref.linksAs,
    RenderChildPages = _ref.renderChildPages;
  if (_isEmpty(links)) {
    return null;
  }
  var transformedLinks = groupLinks(links);
  transformedLinks = [].concat(_toConsumableArray(transformedLinks.filter(function (link) {
    return link.as !== AS_BUTTON;
  })), _toConsumableArray(transformedLinks.filter(function (link) {
    return link.as === AS_BUTTON;
  })));
  return /*#__PURE__*/React.createElement(React.Fragment, null, transformedLinks.map(function (link) {
    var title = link.title,
      url = link.url,
      slug = link.slug,
      pageType = link.pageType,
      as = link.as,
      className = link.className,
      groupedLinks = link.links,
      childPages = link.childPages;
    if (!_isEmpty(groupedLinks)) {
      return /*#__PURE__*/React.createElement(DropdownMenu, {
        key: "".concat(title, "-").concat(links.length),
        title: title,
        options: groupedLinks,
        linksAs: linksAs,
        className: className
      });
    }
    var key = generateKey(title, url, slug);
    if (!_isEmpty(childPages)) {
      return createComponent(RenderChildPages, {
        key: key,
        link: link
      });
    }
    return /*#__PURE__*/React.createElement(BaseLink, {
      key: key,
      title: title,
      url: url,
      slug: slug,
      type: pageType.toLowerCase(),
      as: as,
      className: className
    });
  }));
}
Links.defaultProps = defaultProps;
export default Links;